import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import theme from "../theme/theme";

const withChakraUIProvider = <T extends {}>(
	WrappedComponent: React.ComponentType<T>
) => {
	const Component = (props: T) => (
		<ChakraProvider theme={theme} cssVarsRoot=".magazine-blocks">
			<div className="magazine-blocks">
				<WrappedComponent {...props} />
			</div>
		</ChakraProvider>
	);
	Component.displayName = `withChakraUIProvider`;
	return Component;
};

export default withChakraUIProvider;
